<div class="my-modal__close" (click)="closeModal()">
  <i class="fa-solid fa-times"></i>
</div>

<div class="my-modal__body">
  <app-my-tabs [tabs]="tabs" [defaultTabIndex]="1" *ngIf="!isEdit">
    <div tab1 class="d-flex flex-column w-100 recommand-form" >
      <div class="w-100 d-flex justify-content-center m-3">
        <div class="input-basic w-100">
          <input type="text" placeholder="Search" class="w-50" [(ngModel)]="searchString" (keyup)="getProducts()"/>
        </div>
        
      </div>
   
      <div class="mb-3 prods">
        <common-product-card-view *ngFor="let list of products" (view)="selectProduct($event)" [class.selected]="selectedProduct?.id==list.id"
          [list]="list"
          [isCommunityProduct]="productType == 'community'">
        </common-product-card-view>
      </div>

      <div class="d-flex flex-column justify-content-center align-items-center w-100 p-3" style="border: 2px dashed var(--primary);">
        <div class="input-basic">
          <label for="usp1">Unique Selling Point <span>*</span></label>
          <input type="text" id="usp1"  [(ngModel)]="uspOneFormOneVal"
            placeholder="e.g., 24/7 Emergency Service, 10 Years Experience" />
          <div *ngIf="uspOneFormOneErr" style="color: var(--primary)">{{uspOneFormOneErr}}</div>
        </div>
     

        <div class="input-basic">
          <label for="usp2">Additional Selling Point</label>
          <input type="text" id="usp2" 
          [(ngModel)]="uspTwoFormOneVal"
            placeholder="e.g., Free Consultation, Same Day Service" />
        </div>

        <div class="d-flex justify-content-end w-100">
          <button type="button" class="btn btn-secondary mr-2" (click)="closeModal()">Cancel</button>
          <button type="submit" class="my-button-3" (click)="submitRecommendByProduct()">Support</button>
        </div>
      </div>
    </div>

    <div tab0>
      <form class="recommand-form" [formGroup]="serviceProviderForm" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="input-basic">
              <label>Category <span>*</span></label>
              <app-multi-dropdown placeholder="Category"
                [placeholder]="selectedCategory?.categoryName ?? 'Category'"
                [items]="categoriesList"
                (itemSelected)="onCategoryChange($event)">
              </app-multi-dropdown>
            </div>
          </div>

          <div class="col-12 col-md-6" *ngIf="roleService?.roles?.users?.includes('ATTACH_PRODUCT')">
            <div class="input-basic">
              <label>Selection Subregion</label>
              <app-multi-dropdown [placeholder]="selectedSubRegion ? selectedSubRegion?.name : 'Sub-Region'"
                [items]="subRegionList"
                (itemSelected)="onSubRegionClick($event)"
                [disabled]="!roleService?.roles?.userType.includes('ADMIN')">
              </app-multi-dropdown>
            </div>
          </div>
          <div class="col-12 col-md-4 mb-2 mb-md-0">
            <div class="input-basic" [class.error]="form.name.touched && form.name.invalid">
              <label for="name">What service do you provide? <span class="required">*</span></label>
              <input type="text" id="name" formControlName="name"
                placeholder="e.g., Plumbing, Interior Design, etc." />
              <div *ngIf="form.name.touched && form.name.invalid">Please enter the type of service you provide</div>
            </div>
          </div>

          <div class="col-12 col-md-4 mb-2 mb-md-0">
            <div class="input-basic">
              <label for="company">Business/Company Name</label>
              <input type="text" id="company" formControlName="company"
                placeholder="e.g., ABC Services Pte Ltd" />
            </div>
          </div>

      
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <button class="btn btn-sm btn-outline-primary mb-2 " (click)="$event.preventDefault(); isMidShowing = !isMidShowing">
              <i [ngClass]="isMidShowing ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
            </button>
          </div>
          
        </div>
        
        <div class="row" *ngIf="isMidShowing">
          <div class="col-12 col-md-6">
            <div class="input-basic" [class.error]="form.usp1.touched && form.usp1.invalid">
              <label for="usp1">Unique Selling Point <span>*</span></label>
              <input type="text" id="usp1" formControlName="usp1"
                placeholder="e.g., 24/7 Emergency Service, 10 Years Experience" />
              <div *ngIf="form.usp1.touched && form.usp1.invalid">Please share at least one Unique Selling Point</div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="input-basic" [class.error]="form.contactDetails.touched && form.contactDetails.invalid">
              <label for="contactDetails">Contact Number <span>*</span></label>
              <input type="text" id="contactDetails" formControlName="contactDetails"
                placeholder="e.g., 91234567" />
              <div *ngIf="form.contactDetails.touched && form.contactDetails.invalid">Please enter a valid 8-digit phone number</div>
            </div>
          </div>

         

          
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="input-basic">
              <label for="usp2">Additional Selling Point</label>
              <input type="text" id="usp2" formControlName="usp2"
                placeholder="e.g., Free Consultation, Same Day Service" />
            </div>
          </div>
        </div>

        <div class="upload-image">
          <input type="file" (change)="onFileSelect($event)" accept="image/*" />
          <img loading="lazy" *ngIf="banner_image_url" [src]="banner_image_url" alt="Thumbnail Preview" />
          <div *ngIf="!banner_image_url">
            <svg viewBox="0 0 700 662" fill="none">
              <path d="M122.187 122.422C96.5625 148.047 79.1406 179.609 71.25 214.063H84.1406C98.8281 155.234 142.812 107.891 199.766 88.5156V75.3125C170.781 84.375 144.297 100.312 122.187 122.422Z"
                fill="var(--primary)" />
              <path d="..." fill="#39393A" />
              <path d="M491.25 427.656H473.594L356.016 310.078V661.328H343.516V310.234L226.016 427.656H208.359L349.766 286.25L491.25 427.656Z"
                fill="var(--primary)" />
            </svg>
            <div>Image (Optional)</div>
          </div>
        </div>

        <div class="all-progress" [class.active]="uploadProgress > 1">
          <p>Uploading... {{ uploadProgress }}%</p>
          <div class="progress">
            <div class="progress-bar" role="progressbar" [style.width.%]="uploadProgress"></div>
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-12">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="iHaveTriedService" formControlName="iHaveTriedService" />
              <label class="form-check-label" for="iHaveTriedService">
                I have personally tried the service and highly recommend this to the community
              </label>
            </div>
          </div>
        </div>

        <div class="modal-footer pb-0 px-0">
          <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
          <button type="submit" class="my-button-3" [disabled]="serviceProviderForm.invalid">Recommend</button>
        </div>
      </form>
    </div>
  </app-my-tabs>
  <div *ngIf="isEdit">
    
    <form class="recommand-form" [formGroup]="serviceProviderForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="input-basic">
            <label>Category <span>*</span></label>
            <app-multi-dropdown placeholder="Category"
              [placeholder]="selectedCategory?.categoryName ?? 'Category'"
              [items]="categoriesList"
              (itemSelected)="onCategoryChange($event)">
            </app-multi-dropdown>
          </div>
        </div>

        <div class="col-12 col-md-6" *ngIf="roleService?.roles?.userType.includes('ADMIN')">
          <div class="input-basic">
            <label>Selection Subregion</label>
            <app-multi-dropdown [placeholder]="selectedSubRegion ? selectedSubRegion?.name : 'Sub-Region'"
              [items]="subRegionList"
              (itemSelected)="onSubRegionClick($event)"
              [disabled]="!roleService?.roles?.userType.includes('ADMIN')">
            </app-multi-dropdown>
          </div>
        </div>
        <div class="col-12 col-md-4 mb-2 mb-md-0">
          <div class="input-basic" [class.error]="form.name.touched && form.name.invalid">
            <label for="name">What service do you provide? <span class="required">*</span></label>
            <input type="text" id="name" formControlName="name"
              placeholder="e.g., Plumbing, Interior Design, etc." />
            <div *ngIf="form.name.touched && form.name.invalid">Please enter the type of service you provide</div>
          </div>
        </div>

        <div class="col-12 col-md-4 mb-2 mb-md-0">
          <div class="input-basic">
            <label for="company">Business/Company Name</label>
            <input type="text" id="company" formControlName="company"
              placeholder="e.g., ABC Services Pte Ltd" />
          </div>
        </div>

        <div class="col-12 col-md-4">
          <div class="input-basic" [class.error]="form.contactDetails.touched && form.contactDetails.invalid">
            <label for="contactDetails">Contact Number <span>*</span></label>
            <input type="text" id="contactDetails" formControlName="contactDetails"
              placeholder="e.g., 91234567" />
            <div *ngIf="form.contactDetails.touched && form.contactDetails.invalid">Please enter a valid 8-digit phone number</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6">
          <div class="input-basic" [class.error]="form.usp1.touched && form.usp1.invalid">
            <label for="usp1">Unique Selling Point <span>*</span></label>
            <input type="text" id="usp1" formControlName="usp1"
              placeholder="e.g., 24/7 Emergency Service, 10 Years Experience" />
            <div *ngIf="form.usp1.touched && form.usp1.invalid">Please share at least one Unique Selling Point</div>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="input-basic">
            <label for="usp2">Additional Selling Point</label>
            <input type="text" id="usp2" formControlName="usp2"
              placeholder="e.g., Free Consultation, Same Day Service" />
          </div>
        </div>

        
      </div>

      <div class="upload-image">
        <input type="file" (change)="onFileSelect($event)" accept="image/*" />
        <img loading="lazy" *ngIf="banner_image_url" [src]="banner_image_url" alt="Thumbnail Preview" />
        <div *ngIf="!banner_image_url">
          <svg viewBox="0 0 700 662" fill="none">
            <path d="M122.187 122.422C96.5625 148.047 79.1406 179.609 71.25 214.063H84.1406C98.8281 155.234 142.812 107.891 199.766 88.5156V75.3125C170.781 84.375 144.297 100.312 122.187 122.422Z"
              fill="var(--primary)" />
            <path d="..." fill="#39393A" />
            <path d="M491.25 427.656H473.594L356.016 310.078V661.328H343.516V310.234L226.016 427.656H208.359L349.766 286.25L491.25 427.656Z"
              fill="var(--primary)" />
          </svg>
          <div>Image (Optional)</div>
        </div>
      </div>

      <div class="all-progress" [class.active]="uploadProgress > 1">
        <p>Uploading... {{ uploadProgress }}%</p>
        <div class="progress">
          <div class="progress-bar" role="progressbar" [style.width.%]="uploadProgress"></div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-12">
          <div class="form-check">
            <input type="checkbox" class="form-check-input" id="iHaveTriedService" formControlName="iHaveTriedService" />
            <label class="form-check-label" for="iHaveTriedService">
              I have personally tried the service and highly recommend this to the community
            </label>
          </div>
        </div>
      </div>

      <div class="modal-footer pb-0 px-0">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button type="submit" class="my-button-3" [disabled]="serviceProviderForm.invalid">Recommend</button>
      </div>
    </form>
  </div>
</div>
